import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
const route1 = [
  {
    path: "/guideList",
    name: "guideList",
    component: resolve => require(["@/views/guideList"], resolve),
    meta: { title: "索引" }
  },
  {
    path: "/",
    name: "root",
    redirect: "/guideList"
  }, //发布正式环境需注释，防止访问其他页面
  {
    path: "/shareFromRokiApp",
    name: "shareFromRokiApp", //app分享=>h5----多段烹饪
    component: resolve =>
      require(["@/views/sharePages/lineViewsFromRokiApp"], resolve),
    meta: { title: "多段烹饪", keepAlive: true }
  }, //多段烹饪旧版
  {
    path: "/lineViewsFromRokiApp",
    name: "lineViewsFromRokiApp", //app分享=>h5----多段烹饪
    component: resolve =>
      require(["@/views/sharePages/mutiLineShare"], resolve),
    meta: { title: "多段烹饪", keepAlive: true }
  }, //多段烹饪4.0.3版
  {
    path: "/cookingLineShare",
    name: "cookingLineShare", //app分享=>h5----多段烹饪
    component: resolve =>
      require(["@/views/sharePages/cookingLineShare"], resolve),
    meta: { title: "烹饪曲线", keepAlive: false }
  }, //烹饪曲线分享4.0.3版
  {
    path: "/login",
    name: "login", //app分享=>h5----多段烹饪
    component: resolve => require(["@/views/webLoginRoki"], resolve),
    meta: { title: "ROKI登录", keepAlive: false }
  },
  {
    path: "/wexinUserBindPhone",
    name: "wxlogin", //app分享=>h5----多段烹饪
    component: resolve =>
      require(["@/views/webLoginRoki/wexinUserBindPhone"], resolve),
    meta: { title: "绑定手机号", keepAlive: false }
  },
  {
    path: "/loginOptionsSelect",
    name: "loginOptionsSelect", //app分享=>h5----多段烹饪
    component: resolve =>
      require([
        "@/views/roki/answerQuestionsActivity/loginOptionsSelect"
      ], resolve),
    meta: { title: "ROKI登录", keepAlive: false }
  },
  {
    path: "/loginOptionsSelectTest",
    name: "loginOptionsSelectTest", //app分享=>h5----多段烹饪
    component: resolve =>
      require(["@/views/webLoginRoki/loginOptionsSelect"], resolve),
    meta: { title: "ROKI登录", keepAlive: false }
  },
  {
    path: "/lotteryDraw",
    name: "newKitchenDay",
    component: resolve =>
      require(["@/views/rokiMarchActivity/newKitchenDay"], resolve),
    meta: { title: "抽奖", keepAlive: true }
  },
  // {
  //     path: '/testPoster',
  //     name: 'testPoster',
  //     component: (resolve) => require(['@/views/rokiMarchActivity/newKitchenDay/testcanvas'], resolve),
  //     meta: { title: 'ceshi', keepAlive: true }
  // },
  //awe活动
  // {
  //     path: '/lotteryDraw',
  //     name: 'lotteryDraw',
  //     component: (resolve) => require(['@/views/rokiMarchActivity/lotteryDraw'], resolve),
  //     meta: { title: '抽奖', keepAlive: true }
  // },
  {
    path: "/address/:userId",
    name: "addressEdit",
    component: resolve =>
      require(["@/views/rokiMarchActivity/addressEdit"], resolve),
    meta: { title: "收货地址", keepAlive: false }
  },
  {
    path: "/myRewards/:userId",
    name: "myRewards",
    component: resolve =>
      require(["@/views/rokiMarchActivity/myRewards"], resolve),
    meta: { title: "我的奖品", keepAlive: false }
  },
  {
    path: "/myRewardsOfAct/:userId",
    name: "myRewardsOfAct",
    component: resolve => require(["@/views/roki/myRewards"], resolve),
    meta: { title: "我的奖品", keepAlive: false }
  },
  {
    path: "/addressOfAct/:userId",
    name: "addressOfAct",
    component: resolve => require(["@/views/roki/addressEdit"], resolve),
    meta: { title: "收货地址", keepAlive: false }
  },
  {
    //cookCulture.vue
    path: "/bannerPages/cookCulture",
    name: "cookCulture",
    component: resolve => require(["@/views/bannerPages/cookCulture"], resolve),
    meta: { title: "ROBAM老板 | 烹饪文化活动大预告", keepAlive: true }
  },
  {
    path: "/rewardInfo",
    name: "rewardInfo",
    component: resolve =>
      require(["@/views/bannerPages/rewardInfo/index"], resolve),
    meta: { title: "大家来找茬", keepAlive: true }
  },
  {
    path: "/jiashizao",
    name: "jiashizao",
    component: resolve =>
      require(["@/views/bannerPages/jiashizao/index"], resolve),
    meta: { title: "【ROBAM】家事皂", keepAlive: true }
  },
  {
    path: "/freeTrial",
    name: "freeTrial",
    component: resolve =>
      require(["@/views/bannerPages/freeTrial/index"], resolve),
    meta: { title: "0元先享", keepAlive: true }
  },
  {
    path: "/familyBanner",
    name: "familyBanner",
    component: resolve =>
      require(["@/views/bannerPages/familyBanner"], resolve),
    meta: { title: "家庭板块来咯", keepAlive: true }
  },
  {
    path: "/deliciousArea",
    name: "deliciousArea",
    component: resolve =>
      require(["@/views/bannerPages/deliciousArea"], resolve),
    meta: { title: "美食板块来咯", keepAlive: true }
  },

  //菜谱详情--新版本
  {
    path: "/recipeDetail",
    name: "recipeDetail",
    component: resolve => require(["@/views/roki/recipeDetail"], resolve),
    meta: { title: "", keepAlive: false }
  },
  {
    path: "/nutritionDetail",
    name: "nutritionDetail",
    component: resolve => require(["@/views/roki/nutritionDetail"], resolve),
    meta: { title: "营养图谱", keepAlive: false }
  },
  //h5 灶具小游戏
  {
    path: "/answerHome",
    name: "answerHome",
    component: resolve =>
      require(["@/views/roki/answerQuestionsActivity/answerHome"], resolve),
    meta: { title: "尝尝你的性格是啥味儿？", keepAlive: true }
  },
  {
    path: "/answerQuestionOne",
    name: "answerQuestionOne",
    component: resolve =>
      require([
        "@/views/roki/answerQuestionsActivity/answerQuestionOne"
      ], resolve),
    meta: { title: "尝尝你的性格是啥味儿？", keepAlive: true }
  },
  {
    path: "/questionSubmitName",
    name: "questionSubmitName",
    component: resolve =>
      require([
        "@/views/roki/answerQuestionsActivity/questionSubmitName/index"
      ], resolve),
    meta: { title: "尝尝你的性格是啥味儿？", keepAlive: true }
  },
  {
    path: "/questionResult",
    name: "questionResult",
    component: resolve =>
      require(["@/views/roki/answerQuestionsActivity/questionResult"], resolve),
    meta: { title: "尝尝你的性格是啥味儿？", keepAlive: true }
  },
  {
    path: "/questionPoster",
    name: "questionPoster",
    component: resolve =>
      require([
        "@/views/roki/answerQuestionsActivity/questionResult/questionPoster"
      ], resolve),
    meta: { title: "尝尝你的性格是啥味儿？", keepAlive: true }
  }, //海报测试
  {
    path: "/recipeDetailForQuestion",
    name: "recipeDetailForQuestion",
    component: resolve =>
      require([
        "@/views/roki/answerQuestionsActivity/recipeDetailForQuestion"
      ], resolve),
    meta: { title: "尝尝你的性格是啥味儿？", keepAlive: false }
  },
  {
    path: "/lotteryForQuestion",
    name: "lotteryForQuestion",
    component: resolve =>
      require([
        "@/views/roki/answerQuestionsActivity/lotteryForQuestion"
      ], resolve),
    meta: { title: "尝尝你的性格是啥味儿？", keepAlive: true }
  },
  //618抽奖活动
  {
    path: "/juneLottery",
    name: "juneLottery",
    component: resolve => require(["@/views/rokiJunActivity/lottery"], resolve),
    meta: { title: "618宠粉抽奖", keepAlive: true }
  },

  //敦煌
  {
    path: "/dunHuangHome",
    name: "dunHuangHome",
    component: resolve => require(["@/views/roki/dunhuang/home"], resolve),
    meta: { title: "和大搪一起寻味敦煌", keepAlive: true }
  },
  {
    path: "/dunHuangRecipes",
    name: "dunHuangRecipes",
    component: resolve => require(["@/views/roki/dunhuang/recipes"], resolve),
    meta: { title: "和大搪一起寻味敦煌", keepAlive: true }
  },
  {
    path: "/welcome",
    name: "welcome",
    component: resolve => require(["@/views/roki/dunhuang/welcome"], resolve),
    meta: { title: "和大搪一起寻味敦煌", keepAlive: true }
  },
  {
    path: "/dunHuangGame",
    name: "dunHuangGame",
    component: resolve => require(["@/views/roki/dunhuang/game"], resolve),
    meta: { title: "和大搪一起寻味敦煌", keepAlive: true }
  },
  {
    path: "/dunHuangSuccess",
    name: "dunHuangSuccess",
    component: resolve => require(["@/views/roki/dunhuang/success"], resolve),
    meta: { title: "和大搪一起寻味敦煌", keepAlive: true }
  },
  {
    path: "/themeList",
    name: "themeList",
    component: resolve => require(["@/views/roki/themeList"], resolve),
    meta: { title: "美食专题", keepAlive: true }
  },
  {
    path: "/themeDetail",
    name: "themeDetail",
    component: resolve => require(["@/views/roki/themeDetail"], resolve),
    meta: { title: "主题详情", keepAlive: true }
  },
  {
    path: "/kitchenKnowledge",
    name: "knowledge",
    component: resolve => require(["@/views/roki/knowLedge"], resolve),
    meta: { title: "烹饪知识", keepAlive: true }
  },
  {
    path: "/knowledgeDetail",
    name: "knowledgeDetail",
    component: resolve =>
      require(["@/views/roki/knowLedge/knowledgeDetail"], resolve),
    meta: { title: "", keepAlive: false }
  },
  {
    path: "/knowledgeLabel",
    name: "knowledgeLabel",
    component: resolve =>
      require(["@/views/roki/knowLedge/knowledgeLabel"], resolve),
    meta: { title: "", keepAlive: false }
  },
  {
    path: "/familyCircle",
    name: "familyCircle",
    component: resolve => require(["@/views/roki/familyCircle"], resolve),
    meta: { title: "好友邀请", keepAlive: true }
  },
  {
    path: "/inviteSuccess",
    name: "inviteSuccess",
    component: resolve =>
      require(["@/views/roki/familyCircle/success"], resolve),
    meta: { title: "邀请成功通知", keepAlive: true }
  },
  {
    path: "/downloadApp",
    name: "downloadApp",
    component: resolve => require(["@/views/download"], resolve),
    meta: { title: "下载APP", keepAlive: false }
  },
  {
    path: "/test",
    name: "test",
    component: resolve => require(["@/views/test"], resolve),
    meta: { title: "测试页", keepAlive: false }
  }, //主题切换demo
  {
    path: "/albumsPicture",
    name: "albumsPicture",
    component: resolve =>
      require(["@/views/sharePages/albumShare/albumsPicture"], resolve),
    meta: { title: "ROKI智能烹饪分享", keepAlive: true }
  },
  {
    path: "/previewAlbums",
    name: "previewAlbums",
    component: resolve =>
      require(["@/views/sharePages/albumShare/previewAlbums"], resolve),
    meta: { title: "ROKI智能烹饪分享", keepAlive: false }
  },
  {
    path: "/feedbackStatus",
    name: "feedbackStatus",
    component: resolve =>
      require(["@/views/sharePages/albumShare/feedbackStatus"], resolve),
    meta: { title: "ROKI智能烹饪分享", keepAlive: false }
  },
  //flag换新计划
  {
    path: "/flagHome",
    name: "flagHome",
    component: resolve => require(["@/views/roki/setFlag/home"], resolve),
    meta: { title: "2023Flag焕新计划", keepAlive: true }
  },
  {
    path: "/chooseFlag",
    name: "chooseFlag",
    component: resolve => require(["@/views/roki/setFlag/chooseFlag"], resolve),
    meta: { title: "2023Flag焕新计划", keepAlive: true }
  },
  {
    path: "/chooseFlagTwo",
    name: "chooseFlagTwo",
    component: resolve =>
      require(["@/views/roki/setFlag/chooseFlag/chooseFlagTwo"], resolve),
    meta: { title: "2023Flag焕新计划", keepAlive: true }
  },
  {
    path: "/chooseFlagThree",
    name: "chooseFlagThree",
    component: resolve =>
      require(["@/views/roki/setFlag/chooseFlag/chooseFlagThree"], resolve),
    meta: { title: "2023Flag焕新计划", keepAlive: true }
  },
  {
    path: "/chooseFlagFour",
    name: "chooseFlagFour",
    component: resolve =>
      require(["@/views/roki/setFlag/chooseFlag/chooseFlagFour"], resolve),
    meta: { title: "2023Flag焕新计划", keepAlive: true }
  },
  {
    path: "/signature",
    name: "signature",
    component: resolve => require(["@/views/roki/setFlag/signature"], resolve),
    meta: { title: "2023Flag焕新计划", keepAlive: true }
  },
  {
    path: "/myFlagLists",
    name: "myFlagLists",
    component: resolve =>
      require(["@/views/roki/setFlag/myFlagLists"], resolve),
    meta: { title: "2023Flag焕新计划", keepAlive: true }
  },
  {
    path: "/helpFriendsVerifyFlag",
    name: "helpFriendsVerifyFlag",
    component: resolve =>
      require(["@/views/roki/setFlag/helpFriendsVerifyFlag"], resolve),
    meta: { title: "2023Flag焕新计划", keepAlive: true }
  },
  {
    path: "/posterTest",
    name: "posterTest",
    component: resolve =>
      require(["@/views/roki/setFlag/myFlagLists/flagGeneratePoster"], resolve),
    meta: { title: "2023Flag焕新计划", keepAlive: true }
  },
  //懒人AI厨房大作战
  {
    path: "/cookingChallengeHome",
    name: "cookingChallengeHome",
    component: resolve =>
      require(["@/views/roki/cookingChallenge/cookingChallengeHome"], resolve),
    meta: { title: "AI做饭大挑战", keepAlive: true }
  },
  {
    path: "/selectOptions",
    name: "selectOptions",
    component: resolve =>
      require(["@/views/roki/cookingChallenge/selectOptions"], resolve),
    meta: { title: "AI做饭大挑战", keepAlive: true }
  },
  {
    path: "/aiSignature",
    name: "aiSignature",
    component: resolve =>
      require(["@/views/roki/cookingChallenge/aiSignature"], resolve),
    meta: { title: "AI做饭大挑战", keepAlive: true }
  },
  {
    path: "/aiGenerateRecipe",
    name: "aiGenerateRecipe",
    component: resolve =>
      require(["@/views/roki/cookingChallenge/aiGenerateRecipe"], resolve),
    meta: { title: "AI做饭大挑战", keepAlive: true }
  },
  {
    path: "/shareAiRecipe",
    name: "shareAiRecipe",
    component: resolve =>
      require(["@/views/roki/cookingChallenge/shareAiRecipe"], resolve),
    meta: { title: "AI做饭大挑战", keepAlive: true }
  },
  {
    path: "/aiLottery",
    name: "aiLottery",
    component: resolve =>
      require(["@/views/roki/cookingChallenge/aiLottery"], resolve),
    meta: { title: "AI做饭大挑战", keepAlive: true }
  },
  //AI厨房大作战第二期
  {
    path: "/cookingChallengeHomeOfPeriodTwo",
    name: "cookingChallengeHomeOfPeriodTwo",
    component: resolve =>
      require([
        "@/views/roki/cookingChallengeOfPeriodTwo/cookingChallengeHome"
      ], resolve),
    meta: { title: "AI做饭大挑战", keepAlive: true }
  },
  {
    path: "/selectOptionsOfPeriodTwo",
    name: "selectOptionsOfPeriodTwo",
    component: resolve =>
      require([
        "@/views/roki/cookingChallengeOfPeriodTwo/selectOptions"
      ], resolve),
    meta: { title: "AI做饭大挑战", keepAlive: true }
  },
  {
    path: "/aiSignatureOfPeriodTwo",
    name: "aiSignatureOfPeriodTwo",
    component: resolve =>
      require([
        "@/views/roki/cookingChallengeOfPeriodTwo/aiSignature"
      ], resolve),
    meta: { title: "AI做饭大挑战", keepAlive: true }
  },
  {
    path: "/aiGenerateRecipeOfPeriodTwo",
    name: "aiGenerateRecipeOfPeriodTwo",
    component: resolve =>
      require([
        "@/views/roki/cookingChallengeOfPeriodTwo/aiGenerateRecipe"
      ], resolve),
    meta: { title: "AI做饭大挑战", keepAlive: true }
  },
  {
    path: "/shareAiRecipeOfPeriodTwo",
    name: "shareAiRecipeOfPeriodTwo",
    component: resolve =>
      require([
        "@/views/roki/cookingChallengeOfPeriodTwo/shareAiRecipe"
      ], resolve),
    meta: { title: "AI做饭大挑战", keepAlive: true }
  },
  {
    path: "/aiLotteryOfPeriodTwo",
    name: "aiLotteryOfPeriodTwo",
    component: resolve =>
      require(["@/views/roki/cookingChallengeOfPeriodTwo/aiLottery"], resolve),
    meta: { title: "AI做饭大挑战", keepAlive: true }
  },
  //----人类幼崽养成记
  {
    path: "/threeStoveActHome",
    name: "threeStoveActHome",
    component: resolve =>
      require(["@/views/roki/threeStoveActivity/threeStoveActHome"], resolve),
    meta: { title: "人类幼崽养成记", keepAlive: true }
  },
  {
    path: "/threeStoveAnswerQuestion",
    name: "threeStoveAnswerQuestion",
    component: resolve =>
      require([
        "@/views/roki/threeStoveActivity/threeStoveAnswerQuestion"
      ], resolve),
    meta: { title: "人类幼崽养成记", keepAlive: true }
  },
  {
    path: "/threeStoveAnswerResult",
    name: "threeStoveAnswerResult",
    component: resolve =>
      require([
        "@/views/roki/threeStoveActivity/threeStoveAnswerResult"
      ], resolve),
    meta: { title: "人类幼崽养成记", keepAlive: true }
  },
  {
    path: "/stoveActLottery",
    name: "stoveActLottery",
    component: resolve =>
      require(["@/views/roki/threeStoveActivity/stoveActLottery"], resolve),
    meta: { title: "人类幼崽养成记", keepAlive: true }
  },
  {
    path: "/shareStoveAct",
    name: "shareStoveAct",
    component: resolve =>
      require(["@/views/roki/threeStoveActivity/shareStoveAct"], resolve),
    meta: { title: "人类幼崽养成记", keepAlive: true }
  },
  {
    path: "/threeStoveProductDetail",
    name: "threeStoveProductDetail",
    component: resolve =>
      require([
        "@/views/roki/threeStoveActivity/threeStoveProductDetail"
      ], resolve),
    meta: { title: "人类幼崽养成记", keepAlive: true }
  },
  {
    path: "/userExperience",
    name: "userExperience",
    component: resolve =>
      require(["@/views/roki/userExperienceAct/home"], resolve),
    meta: { title: "ROKI体验官有奖招募", keepAlive: true }
  },
  {
    path: "/userExperienceQst",
    name: "userExperienceQst",
    component: resolve =>
      require(["@/views/roki/userExperienceAct/question"], resolve),
    meta: { title: "ROKI体验官有奖招募", keepAlive: true }
  },
  {
    path: "/userExperienceLottery",
    name: "userExperienceLottery",
    component: resolve =>
      require(["@/views/roki/userExperienceAct/lottery"], resolve),
    meta: { title: "ROKI体验官有奖招募", keepAlive: true }
  },
  {
    path: "/userExperienceNew",
    name: "userExperienceNew",
    component: resolve =>
      require(["@/views/roki/userExperienceNew/home"], resolve),
    meta: { title: "ROKI体验官有奖招募", keepAlive: true }
  },
  {
    path: "/userExperienceNewQst",
    name: "userExperienceNewQst",
    component: resolve =>
      require(["@/views/roki/userExperienceNew/question"], resolve),
    meta: { title: "ROKI体验官有奖招募", keepAlive: true }
  },
  {
    path: "/userExperienceNewLottery",
    name: "userExperienceNewLottery",
    component: resolve =>
      require(["@/views/roki/userExperienceNew/lottery"], resolve),
    meta: { title: "ROKI体验官有奖招募", keepAlive: true }
  },

  {
    path: "/wxGetCodeLogin",
    name: "wxGetCodeLogin",
    component: resolve =>
      require(["@/views/webLoginRoki/wxGetCodeLogin"], resolve),
    meta: { title: "微信授权登录", keepAlive: false }
  },
  {
    path: "/favoriteRecipeHome",
    name: "favoriteRecipeHome",
    component: resolve =>
      require(["@/views/roki/findFavoriteRecipe/favoriteRecipeHome"], resolve),
    meta: { title: "寻找最赞家常菜", keepAlive: true }
  },
  {
    path: "/favoriteRecipeSelections",
    name: "favoriteRecipeSelections",
    component: resolve =>
      require(["@/views/roki/findFavoriteRecipe/selections"], resolve),
    meta: { title: "寻找最赞家常菜", keepAlive: true }
  },
  {
    path: "/favoriteRecipeChoosed",
    name: "favoriteRecipeChoosed",
    component: resolve =>
      require([
        "@/views/roki/findFavoriteRecipe/favoriteRecipeChoosed"
      ], resolve),
    meta: { title: "寻找最赞家常菜", keepAlive: true }
  },
  {
    path: "/favoriteRecipeDetail",
    name: "favoriteRecipeDetail",
    component: resolve =>
      require([
        "@/views/roki/findFavoriteRecipe/favoriteRecipeDetail"
      ], resolve),
    meta: { title: "寻找最赞家常菜", keepAlive: true }
  },
  {
    path: "/favoriteRecipeUpload",
    name: "favoriteRecipeUpload",
    component: resolve =>
      require([
        "@/views/roki/findFavoriteRecipe/favoriteRecipeUpload"
      ], resolve),
    meta: { title: "寻找最赞家常菜", keepAlive: true }
  },
  {
    path: "/favoriteRecipeUploadSuccess",
    name: "favoriteRecipeUploadSuccess",
    component: resolve =>
      require([
        "@/views/roki/findFavoriteRecipe/favoriteRecipeUploadSuccess"
      ], resolve),
    meta: { title: "寻找最赞家常菜", keepAlive: true }
  },
  {
    path: "/favoriteRecipeUploadSuccessTestPoster",
    name: "favoriteRecipeUploadSuccessTestPoster",
    component: resolve =>
      require([
        "@/views/roki/findFavoriteRecipeZongyi/favoriteRecipeUploadSuccess/favoriteRecipePoster"
      ], resolve),
    meta: { title: "海报测试---寻找最赞家常菜", keepAlive: true }
  },
  {
    path: "/favoriteRecipeShare",
    name: "favoriteRecipeShare",
    component: resolve =>
      require(["@/views/roki/findFavoriteRecipe/favoriteRecipeShare"], resolve),
    meta: { title: "寻找最赞家常菜", keepAlive: true }
  },
  {
    path: "/favoriteRecipeMyWorks",
    name: "favoriteRecipeMyWorks",
    component: resolve =>
      require([
        "@/views/roki/findFavoriteRecipe/favoriteRecipeMyWorks"
      ], resolve),
    meta: { title: "寻找最赞家常菜", keepAlive: true }
  },
  {
    path: "/favoriteRecipeTopsRank",
    name: "favoriteRecipeTopsRank",
    component: resolve =>
      require([
        "@/views/roki/findFavoriteRecipe/favoriteRecipeTopsRank"
      ], resolve),
    meta: { title: "寻找最赞家常菜", keepAlive: true }
  },
  //科技节
  {
    path: "/WhatUsersWish",
    name: "scienceFestival",
    component: resolve => require(["@/views/roki/scienceFestival"], resolve),
    meta: { title: "用户交流大会有奖留言", keepAlive: false }
  },
  {
    path: "/leaveMsgPage",
    name: "leaveMsgPage",
    component: resolve =>
      require(["@/views/roki/scienceFestival/leaveMsgPage"], resolve),
    meta: { title: "用户交流大会有奖留言", keepAlive: false }
  },

  {
    path: "/scienceOver",
    name: "scienceOver",
    component: resolve =>
      require(["@/views/roki/scienceFestival/scienceOver"], resolve),
    meta: { title: "用户交流大会有奖留言", keepAlive: false }
  },
  {
    path: "/leaveMsgSubmited",
    name: "leaveMsgSubmited",
    component: resolve =>
      require(["@/views/roki/scienceFestival/leaveMsgSubmited"], resolve),
    meta: { title: "用户交流大会有奖留言", keepAlive: false }
  },
  {
    path: "/votePage",
    name: "votePage",
    component: resolve =>
      require(["@/views/roki/scienceFestival/votePage"], resolve),
    meta: { title: "用户交流大会有奖留言", keepAlive: false }
  }
];
const act2 = [
  {
    path: "/favoriteRecipeHomeZongyi",
    name: "favoriteRecipeHomeZongyi",
    component: resolve =>
      require([
        "@/views/roki/findFavoriteRecipeZongyi/favoriteRecipeHome"
      ], resolve),
    meta: { title: "ROKI美食挑战赛", keepAlive: true }
  },
  {
    path: "/favoriteRecipeSelectionsZongyi",
    name: "favoriteRecipeSelectionsZongyi",
    component: resolve =>
      require(["@/views/roki/findFavoriteRecipeZongyi/selections"], resolve),
    meta: { title: "ROKI美食挑战赛", keepAlive: true }
  },
  {
    path: "/favoriteRecipeChoosedZongyi",
    name: "favoriteRecipeChoosedZongyi",
    component: resolve =>
      require([
        "@/views/roki/findFavoriteRecipeZongyi/favoriteRecipeChoosed"
      ], resolve),
    meta: { title: "ROKI美食挑战赛", keepAlive: true }
  },
  {
    path: "/favoriteRecipeDetailZongyi",
    name: "favoriteRecipeDetailZongyi",
    component: resolve =>
      require([
        "@/views/roki/findFavoriteRecipeZongyi/favoriteRecipeDetail"
      ], resolve),
    meta: { title: "ROKI美食挑战赛", keepAlive: true }
  },
  {
    path: "/favoriteRecipeUploadZongyi",
    name: "favoriteRecipeUploadZongyi",
    component: resolve =>
      require([
        "@/views/roki/findFavoriteRecipeZongyi/favoriteRecipeUpload"
      ], resolve),
    meta: { title: "ROKI美食挑战赛", keepAlive: true }
  },
  {
    path: "/favoriteRecipeUploadSuccessZongyi",
    name: "favoriteRecipeUploadSuccessZongyi",
    component: resolve =>
      require([
        "@/views/roki/findFavoriteRecipeZongyi/favoriteRecipeUploadSuccess"
      ], resolve),
    meta: { title: "ROKI美食挑战赛", keepAlive: true }
  },
  {
    path: "/favoriteRecipeUploadSuccessTestPosterZongyi",
    name: "favoriteRecipeUploadSuccessTestPosterZongyi",
    component: resolve =>
      require([
        "@/views/roki/findFavoriteRecipeZongyi/favoriteRecipeUploadSuccess/favoriteRecipePoster"
      ], resolve),
    meta: { title: "海报测试---ROKI美食挑战赛", keepAlive: true }
  },
  {
    path: "/favoriteRecipeShareZongyi",
    name: "favoriteRecipeShareZongyi",
    component: resolve =>
      require([
        "@/views/roki/findFavoriteRecipeZongyi/favoriteRecipeShare"
      ], resolve),
    meta: { title: "ROKI美食挑战赛", keepAlive: true }
  },
  {
    path: "/favoriteRecipeMyWorksZongyi",
    name: "favoriteRecipeMyWorksZongyi",
    component: resolve =>
      require([
        "@/views/roki/findFavoriteRecipeZongyi/favoriteRecipeMyWorks"
      ], resolve),
    meta: { title: "ROKI美食挑战赛", keepAlive: true }
  },
  {
    path: "/favoriteRecipeTopsRankZongyi",
    name: "favoriteRecipeTopsRankZongyi",
    component: resolve =>
      require([
        "@/views/roki/findFavoriteRecipeZongyi/favoriteRecipeTopsRank"
      ], resolve),
    meta: { title: "ROKI美食挑战赛", keepAlive: true }
  }
];
const act3 = [
  {
    path: "/openBlindBoxHome",
    name: "openBlindBoxHome",
    component: resolve =>
      require(["@/views/roki/yearEndOpenBlindBox/openBlindBoxHome"], resolve),
    meta: { title: "2024 ROKI新年盲盒", keepAlive: true }
  },
  {
    path: "/blindThemeDetail",
    name: "blindThemeDetail",
    component: resolve =>
      require(["@/views/roki/yearEndOpenBlindBox/themeDetail"], resolve),
    meta: { title: "主题详情", keepAlive: false }
  },
  {
    path: "/blindRecipeDetail",
    name: "blindRecipeDetail",
    component: resolve =>
      require(["@/views/roki/yearEndOpenBlindBox/recipeDetail"], resolve),
    meta: { title: "菜谱详情", keepAlive: false }
  },
  {
    path: "/cookWorksUpload",
    name: "cookWorksUpload",
    component: resolve =>
      require(["@/views/roki/yearEndOpenBlindBox/cookWorksUpload"], resolve),
    meta: { title: "新作品", keepAlive: false }
  },
  {
    path: "/blindStaticRecipeList",
    name: "blindStaticRecipeList",
    component: resolve =>
      require(["@/views/roki/yearEndOpenBlindBox/staticRecipeList"], resolve),
    meta: { title: "2024 ROKI新年盲盒", keepAlive: false }
  }
]; //12月跨年开盲盒活动
const act4 = [
  {
    path: "/FestivalWorksVerify",
    name: "FestivalWorksVerify",
    component: resolve =>
      require(["@/views/roki/findFavoriteRecipeFestival/worksReview"], resolve),
    meta: { title: "晒出咱家团圆饭作品审核", keepAlive: true }
  },
  {
    path: "/favoriteRecipeHomeFestival",
    name: "favoriteRecipeHomeFestival",
    component: resolve =>
      require([
        "@/views/roki/findFavoriteRecipeFestival/favoriteRecipeHome"
      ], resolve),
    meta: { title: "晒出咱家团圆饭", keepAlive: true }
  },
  {
    path: "/favoriteRecipePeriodsShowFestival",
    name: "favoriteRecipePeriodsShowFestival",
    component: resolve =>
      require([
        "@/views/roki/findFavoriteRecipeFestival/preSelection"
      ], resolve),
    meta: { title: "晒出咱家团圆饭", keepAlive: true }
  },
  {
    path: "/favoriteRecipeSelectionsFestival",
    name: "favoriteRecipeSelectionsFestival",
    component: resolve =>
      require(["@/views/roki/findFavoriteRecipeFestival/selections"], resolve),
    meta: { title: "晒出咱家团圆饭", keepAlive: true }
  },
  {
    path: "/favoriteRecipeChoosedFestival",
    name: "favoriteRecipeChoosedFestival",
    component: resolve =>
      require([
        "@/views/roki/findFavoriteRecipeFestival/favoriteRecipeChoosed"
      ], resolve),
    meta: { title: "晒出咱家团圆饭", keepAlive: true }
  },
  {
    path: "/favoriteRecipeDetailFestival",
    name: "favoriteRecipeDetailFestival",
    component: resolve =>
      require([
        "@/views/roki/findFavoriteRecipeFestival/favoriteRecipeDetail"
      ], resolve),
    meta: { title: "晒出咱家团圆饭", keepAlive: true }
  },
  {
    path: "/favoriteRecipeUploadFestival",
    name: "favoriteRecipeUploadFestival",
    component: resolve =>
      require([
        "@/views/roki/findFavoriteRecipeFestival/favoriteRecipeUpload"
      ], resolve),
    meta: { title: "晒出咱家团圆饭", keepAlive: true }
  },
  {
    path: "/favoriteRecipeUploadSuccessFestival",
    name: "favoriteRecipeUploadSuccessFestival",
    component: resolve =>
      require([
        "@/views/roki/findFavoriteRecipeFestival/favoriteRecipeUploadSuccess"
      ], resolve),
    meta: { title: "晒出咱家团圆饭", keepAlive: true }
  },
  {
    path: "/favoriteRecipeUploadSuccessTestPosterFestival",
    name: "favoriteRecipeUploadSuccessTestPosterFestival",
    component: resolve =>
      require([
        "@/views/roki/findFavoriteRecipeFestival/favoriteRecipeUploadSuccess/shaiFanPoster"
      ], resolve),
    meta: { title: "海报测试---1月晒团圆饭活动", keepAlive: true }
  },
  {
    path: "/favoriteRecipeShareFestival",
    name: "favoriteRecipeShareFestival",
    component: resolve =>
      require([
        "@/views/roki/findFavoriteRecipeFestival/favoriteRecipeShare"
      ], resolve),
    meta: { title: "晒出咱家团圆饭", keepAlive: true }
  },
  {
    path: "/favoriteRecipeMyWorksFestival",
    name: "favoriteRecipeMyWorksFestival",
    component: resolve =>
      require([
        "@/views/roki/findFavoriteRecipeFestival/favoriteRecipeMyWorks"
      ], resolve),
    meta: { title: "晒出咱家团圆饭", keepAlive: true }
  },
  {
    path: "/favoriteRecipeTopsRankFestival",
    name: "favoriteRecipeTopsRankFestival",
    component: resolve =>
      require([
        "@/views/roki/findFavoriteRecipeFestival/favoriteRecipeTopsRank"
      ], resolve),
    meta: { title: "晒出咱家团圆饭", keepAlive: true }
  }
]; //1月晒团圆饭活动
const router = new Router({
  routes: [
    ...route1,
    ...act2,
    ...act3,
    ...act4,
    {
      path: "/guideBindCard",
      name: "guideBindCard",
      component: resolve => require(["@/views/guideBindCard/index"], resolve),
      meta: { title: "2024 ROKI新年盲盒", keepAlive: false }
    },
    {
      path: "/dataToJSON",
      name: "dataToJSON",
      component: resolve => require(["@/views/components/dataToJSON"], resolve),
      meta: { title: "菜谱数据格式转换", keepAlive: false }
    },
    {
      path: "/wxSnapeModeTest",
      name: "wxSnapeModeTest",
      component: resolve =>
        require([
          "@/views/webLoginRoki/loginOptionsSelect/quiteSnapeTest"
        ], resolve),
      meta: { title: "微信test-snsapi_base", keepAlive: false }
    },
    {
      path: "/wxAskSnapeModeTest",
      name: "wxAskSnapeModeTest",
      component: resolve =>
        require([
          "@/views/webLoginRoki/loginOptionsSelect/askSnapeTest"
        ], resolve),
      meta: { title: "微信快照页命中-snsapi_info", keepAlive: false }
    }
    // {
    //     path: '/wechatJssdkTest',
    //     name: 'wechatJssdkTest',
    //     component: (resolve) => require(['@/views/test/wechatJssdkTest'], resolve),
    //     meta: { title: '微信jssdk测试页', keepAlive: true }
    //  },
  ],
  scrollBehavior(to, from, savedPosition) {
    console.log("savedPosition---", savedPosition);

    if (to.path == "/recipeDetail") {
      return { x: 0, y: 0 };
    }
    if (savedPosition) {
      //   const { y } = savedPosition;
      //   to.meta.savedPosition = y || 0;
      return savedPosition;
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop;
      }
      return { x: 0, y: to.meta.savedPosition || 0 };
    }
  }
});
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // Vue.prototype.transitionName = "slide-none";
  // debugger;
  // if (from.meta.tree > to.meta.tree) {
  //   // 后退,想右滑动
  //   Vue.prototype.transitionName = "slide-right";
  //   from.meta.keepAlive = false;
  //   to.meta.keepAlive = true;
  // } else if (from.meta.tree < to.meta.tree) {
  //   // 前进,想左滑动
  //   Vue.prototype.transitionName = "slide-left";
  //   from.meta.keepAlive = true;
  //   to.meta.keepAlive = false;
  // } else {
  //   // 同一层级,无动画
  //   Vue.prototype.transitionName = "";
  //   from.meta.keepAlive = true;
  //   to.meta.keepAlive = true;
  // }
  next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js